import { SHOW_SNACKBAR, REMOVE_SNACKBAR, SnackbarActionTypes } from "./SnackbarTypes";

import { UpdateProductSequencePayload } from "../product-list/ProductListTypes";

export interface SnackbarState {
  notifications: Array<{
    key: string;
    message: string;
    variant: "success" | "error" | "warning" | "info";
    categoryId?: string;
    errorMessage?: string;
    retryPayload?: UpdateProductSequencePayload;
  }>;
}

const initialState: SnackbarState = {
  notifications: [],
};

export const snackbarReducer = (
  state: SnackbarState = initialState,
  action: SnackbarActionTypes,
): SnackbarState => {
  switch (action.type) {
    case SHOW_SNACKBAR: {
      const key = action.payload.key || `snackbar-${Date.now()}-${Math.random()}`;
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            key,
            message: action.payload.message,
            variant: action.payload.variant,
            categoryId: action.payload.categoryId,
            errorMessage: action.payload.errorMessage,
            retryPayload: action.payload.retryPayload,
          },
        ],
      };
    }
    case REMOVE_SNACKBAR: {
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.key !== action.payload.key,
        ),
      };
    }
    default:
      return state;
  }
};
